<app-spinner-overlay></app-spinner-overlay>

@if (data.titoloESRS) {
  <div
    style="
      font-family: Abel;
      font-size: 28px;
      color: var(--mat-color-accent);
      margin-top: 20px;
      margin-bottom: 10px;
    "
  >
    {{ titolo }}
  </div>
  <div class="titolo-elem-padre">
    <span style="font-size: 14px">{{ data.titoloESRS.etichetta }}</span>
    {{ data.titoloESRS.titolo }}
  </div>
} @else {
  <app-titolo-subtitolo [titolo]="titolo" [subTitolo]="sottotitolo"></app-titolo-subtitolo>
}

<div mat-dialog-content class="dialog-center-cont">
  <form [formGroup]="formImpatti">
    <div appFormContainer [larghezza]="3">
      <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
        <mat-label>Titolo</mat-label>
        <input matInput placeholder="Titolo" formControlName="titolo" />
        <mat-error appFormError></mat-error>
      </mat-form-field>

      @if (data.contesto === 'doppiamaterialita') {
        <div appFormElement [larghezza]="12" class="segnalazione" [ngClass]="'show'">
          <mat-icon>error</mat-icon>
          <div class="descrizione">
            Definire le caratteristiche dell’impatto. Per la valutazione degli IRO si necessita la
            compilazione dei primi due campi.
          </div>
        </div>
      }

      <mat-form-field
        class="input-form"
        appFormElement
        [larghezza]="1"
        [riempi]="true"
        *ngIf="this.data.contesto"
      >
        <mat-label>Impatto Potenziale/Effettivo</mat-label>
        <mat-select
          formControlName="impattoPotenzialeEffettivo"
          (selectionChange)="onSelectionChange()"
          placeholder="Impatto Potenziale/Effettivo"
          [(value)]="selectedImpattoPotEff"
        >
          <mat-option *ngFor="let impt of arrayImpattoPotEff" [value]="impt.codice">{{
            impt.descrizione
          }}</mat-option>
        </mat-select>
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <mat-form-field
        class="input-form"
        appFormElement
        [larghezza]="1"
        [riempi]="true"
        *ngIf="this.data.contesto"
      >
        <mat-label>Impatto Positivo/Negativo</mat-label>
        <mat-select
          formControlName="impattoPositivoNegativo"
          (selectionChange)="onSelectionChange()"
          placeholder="Impatto Positivo/Negativo"
          [(value)]="selectedImpattoPosNeg"
        >
          <mat-option *ngFor="let impt of arrayImpattoPosNeg" [value]="impt.codice">{{
            impt.descrizione
          }}</mat-option>
        </mat-select>
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="this.data.contesto === 'doppiamaterialita'"
        class="input-form"
        appFormElement
        [larghezza]="1"
        [riempi]="true"
      >
        <mat-label>Impatto Diretto/Indiretto</mat-label>
        <mat-select
          formControlName="impattoDirettoIndiretto"
          placeholder="Impatto Diretto/Indiretto"
          multiple
        >
          <mat-option *ngFor="let impt of arrayDirettoIndiretto" [value]="impt.codice">{{
            impt.descrizione
          }}</mat-option>
        </mat-select>
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="this.data.contesto === 'doppiamaterialita'"
        class="input-form"
        appFormElement
        [larghezza]="1"
        [riempi]="true"
      >
        <mat-label>Orizzonte temporale</mat-label>
        <mat-select formControlName="orizzontiTemporali" placeholder="Orizzonte temporale" multiple>
          <mat-option *ngFor="let impt of arrayOrizzontiTemporali" [value]="impt.codice">{{
            impt.descrizione
          }}</mat-option>
        </mat-select>
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <div
        *ngIf="this.data.contesto && this.data.contesto !== 'doppiamaterialita'"
        class="segnalazione"
        [ngClass]="{ show: isIconaGuida }"
      >
        <div style="display: flex; align-items: center">
          <mat-icon>error</mat-icon>
        </div>
        <div class="descrizione">
          {{ guidaDescrizione }}
        </div>
      </div>

      @if (data.contesto === 'doppiamaterialita') {
        <div appFormElement [larghezza]="12" class="segnalazione" [ngClass]="'show'">
          <mat-icon>error</mat-icon>
          <div class="descrizione">
            Da quali fattori si genera l’impatto? Descrivere le caratteristiche, le azioni e gli
            aspetti aziendali e di contesto che danno origine all’impatto
          </div>
        </div>
      }

      <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
        <mat-label>Descrizione</mat-label>
        <textarea
          matInput
          placeholder="Descrizione"
          formControlName="descrizione"
          rows="4"
        ></textarea>
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <ng-container *ngIf="data.isFatturato === true">
        <div class="segnalazioneFatt" appFormElement [larghezza]="12" [riempi]="true">
          <div style="display: flex; align-items: center">
            <mat-icon>error</mat-icon>
          </div>
          <div class="descrizione">
            Impostare un range di fatturato e settore per consigliare alle aziende corrispondenti di
            utilizzare questo impatto in configurazione Survey.
          </div>
        </div>

        <mat-form-field appFormElement [larghezza]="1" [riempi]="true">
          <mat-label>Fatturato DA</mat-label>
          <input
            matInput
            placeholder="Fatturato DA"
            formControlName="fatturatoDa"
            type="number"
            appInputNumber
            inputmode="numeric"
            min="0"
            max="999999999999"
            (keydown)="onKeyDown($event)"
          />
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <mat-form-field appFormElement [larghezza]="1" [riempi]="true">
          <mat-label>Fatturato A</mat-label>
          <input
            matInput
            placeholder="Fatturato A"
            formControlName="fatturatoA"
            type="number"
            appInputNumber
            inputmode="numeric"
            min="0"
            max="999999999999"
            (keydown)="onKeyDown($event)"
          />
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <mat-form-field appFormElement [larghezza]="1" [riempi]="true">
          <mat-label>TAG</mat-label>
          <input matInput placeholder="TAG" formControlName="tag" />
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <mat-form-field class="input-form" appFormElement [larghezza]="3" [riempi]="true">
          <mat-label>Settori</mat-label>
          <mat-select
            formControlName="settori"
            placeholder="Settori"
            [(value)]="selectedSettori"
            multiple
            [compareWith]="compareSettori"
          >
            <mat-option *ngFor="let set of arraySettori" [value]="set">{{ set.titolo }}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
      <!--       @if (data.contesto) {
        @if (this.formImpatti.get('note')?.value || mostraNote) {
          <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
            <mat-label>Note per il compilatore</mat-label>
            <textarea
              matInput
              placeholder="Note per il compilatore"
              formControlName="note"
              rows="4"
            ></textarea>
            <mat-error appFormError></mat-error>
          </mat-form-field>
        }
        @if (!this.formImpatti.get('note')?.value) {
          <button mat-stroked-button class="bottone-note-compilatore" (click)="mostraNoteFn()">
            <mat-icon class="material-icons-outlined"> add</mat-icon>
            {{ mostraNote ? 'Nascondi' : 'Assegna' }} note per il compilatore
          </button>
        }
      } -->
    </div>
  </form>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</div>
